module.exports = __webpack_public_path__ + "static/VCB-Tuan-17a124b9baa4693f11e49a1dd0b40054.jpg";